import axios from 'axios'
import CardView from 'components/app/support-desk/tickets-layout/CardView'
import TableView from 'components/app/support-desk/tickets-layout/TableView'
import CommonBreadCrumb from 'components/commonbreadcrumb/CommonBreadCrumb'
import ShimmerUI from 'components/ShimmerUI/PatientShimmer'
import React, { useEffect } from 'react'
import { Alert } from 'react-bootstrap'
import paths from 'routes/paths'

const UserHelpMain = () => {
  const [tableData, setTableData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);

  useEffect(() => {
    fetchData()
  }, [])

  const fetchData = async () => {
    let tokenStr = localStorage.getItem("accessToken");
    setLoading(true);
    try {
      const { data } = await axios.get(`${process.env.REACT_APP_SERVER_URL}/support/list`, { headers: { 'Authorization': `Bearer ${tokenStr}` } });
      let results = [];
      data.data.map(ticket => {
        results.push({
          id: ticket.id,
          subject: ticket.subject,
          status: ticket.status,
          // created_at: ticket.created_at,
          // updated_at: ticket.updated_at,
          name: ticket.created_by_name,
          priority: ticket.priority,
        })
      })
      setTableData(results);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      console.log('Fetch attempt completed');
      setLoading(false);
    }
  }

  const breadcrumbItems = [
        { name: 'Dashboard', href: '/main', isActive: false },
        { name: 'help-center', href: paths.UserHelp, isActive: true }
    ];
  return (
    <div>
      <CommonBreadCrumb breadcrumbItems={breadcrumbItems} />
      {loading ? <ShimmerUI /> : tableData.length === 0 ? <Alert variant="info" className="text-center fw-bold">
        No tickets found.
      </Alert> :
        <TableView tableData={tableData} />
      }
    </div>
  )
}

export default UserHelpMain